import React, { useEffect, useState } from 'react'
import PageTitle from 'components/atoms/PageTitle'
import AppModal from '../../../components/organisms/CustomModal'
import CodeInput from 'components/atoms/CodeInput'
import { useLocation, useNavigate } from 'react-router-dom'
import Button from 'components/atoms/Button'
import { BASE_URL, postRequest } from 'services/http'
import { getValues, setValues } from 'services/storage'
import Alert from 'components/atoms/Alert'
import { connect } from 'react-redux'
import { useSelector, useDispatch } from 'react-redux'

const Configure2FA = (props) => {
  const [loading, setLoading] = useState(false);
  const [OTPChange, setOTPChange] = useState("");
  const [OTP, setOTP] = useState("");
  const userEmail = useSelector((state: any) => state.auth.user_authData.partnerEmail);

  const formComplete = OTP.length === 6;
  const disabledBtn = formComplete === false || loading === true;
  const dispatch = useDispatch();

  const verifyConfiguration = async (reqData: any) => {
    //checking OTP the user has entered
    setLoading(true);
    const res = await postRequest(
      `${BASE_URL}api/v1/mfa/validate`,
      {
        "Content-Type": "application/json",
        Authorization: `Bearer ${props.bearerToken}`,
      },
      reqData
    );

    if (res?.data?.responseCode === "00") {
      Alert("success", res?.data?.message);
      props.setShowModal(false);
      setLoading(false);
      setValues("two_fa_enabled", "true");
    } else {
      setLoading(false);
      res?.data?.message !== null && Alert("error", res?.data?.message);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const reqData = {
      userEmail: userEmail,
      otp: OTP,
      category: "MULTI_FACTOR_AUTHENTICATION",
    };

    if (OTP !== "") {
      verifyConfiguration(reqData);
    } else {
      Alert("error", "Invalid, OTP cannot be empty.");
    }
  };

  return (
    <AppModal
      handleClose={() => props.setShowModal(false)}
      modalStyle="desktop:w-1/4 w-[45%] mobile:w-3/4 bg-white min-h-[300px] h-fit z-30 my-[10rem] mx-auto left-0 right-0 animate-slide_up rounded-lg p-6 shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all"
      contentStyle=""
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <PageTitle
          pageTitle="Configure 2FA"
          subTitle="Set up Two Factor Authentication on your account"
          subTitleStyle=""
          style="!mt-0 !gap-1"
        />
        <span className="flex flex-col gap-5">
          <CodeInput
            label="Enter the OTP you just received in your mail"
            labelStyle="font-normal text-sm leading-6 text-Black2"
            length={6}
            onChange={(v) => setOTPChange(v)}
            type={"numeric"}
            secret={false}
            onComplete={(p) => setOTP(p)}
          />

          <Button
            btnType="submit"
            btnText={loading ? "Loading..." : "Verify"}
            btnStyle={`${
              disabledBtn ? "cursor-not-allowed" : ""
            } bg-black text-white px-6 py-3 w-full`}
            disabled={disabledBtn}
          />
        </span>
      </form>
    </AppModal>
  );
}


const mapStateToProps = (state: any) => ({
    bearerToken: state.auth.user_authData.token.token,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Configure2FA);